import * as React from "react";

const KHLogo = (props) => (
  <img
    src="https://d337qwjyep6w7b.cloudfront.net/assets/SCA_Logo.png"
    height={70}
  />
);

export default KHLogo;
